import React, {Fragment} from 'react';
import { useAuth } from '../../Context/Context';
import { WavyLink } from "react-wavy-transitions";

import img0 from "../../Images/Servicios/ADS/0.png"
import img1 from "../../Images/Servicios/ADS/1.png"

import icon1 from "../../Images/Servicios/Iconos/3.png";
import icon2 from "../../Images/Servicios/Iconos/4.png";
import icon3 from "../../Images/Servicios/Iconos/9.png";
import icon4 from "../../Images/Servicios/Iconos/7.png"; 

import img2 from "../../Images/Servicios/Desarrollo/1.png"
import img3 from "../../Images/Servicios/Desarrollo/2.png"
import img4 from "../../Images/Servicios/Desarrollo/5.png"
import img5 from "../../Images/Servicios/Desarrollo/6.png"

import imgServiciosBlanco from "../../Images/servicios_blanco_2.png";

import Efectos from '../../Components/Efectos';
import Contacto from '../../Components/Contacto';
import Portafolio from '../../Components/Portafolio';


const ADS = () => {
    const { direction, cambio } = useAuth();

    return(
        <Fragment>
            <div>
                <div className='fondo_servicio_4'>
                    {window.screen.width <= 550 ? (
                        <div>
                            <div>
                                <p className='sub_titulo_nv_4' style={{marginBottom:"10px", color:"#ffffff"}}>
                                    <span className='titulo_nv_2' style={{color:"#ED3E75", lineHeight:"30px", marginBottom:"10px"}}>
                                        Campañas <br/> Google ADS <br/>
                                    </span>
                                    El principio <br/> de un gran cambio
                                </p>
                                <div className='cont_7'>
                                    <p>
                                        Realizamos campañas de búsqueda con anuncios de texto o de llamada que se 
                                        muestran en los resultados de búsqueda de Google.
                                    </p>
                                </div>
                            </div>
                            <div>
                                <Efectos activado={true}>
                                    <img className='scroll-element js-scroll fade-in-bottom' src={img0} alt="" style={{width:"100%", maxWidth:"1485px"}}/>
                                </Efectos>
                                <p className='center' style={{color:"#707070"}}>
                                    Pautar este tipo de campañas con el <br/>
                                    correcto presupuesto, segmentación <br/>
                                    geográfica y otras opciones de <br/>
                                    configuración garantizan nuevos <br/>
                                    prospectos de clientes para tu negocio. 
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div>
                                <p className='sub_titulo_nv_4' style={{color:"#ffffff"}}>
                                    <span className='titulo_nv_2' style={{color:"#ED3E75"}}>
                                        Campañas Google ADS <br/>
                                    </span>
                                    El principio de un gran cambio
                                </p>
                                <div className='cont_7 cont_7_2'>
                                    <p>
                                        Realizamos campañas de búsqueda con anuncios de texto o de llamada que se 
                                        muestran en los resultados de búsqueda de Google.
                                    </p>
                                </div>
                            </div>
                            <Efectos activado={true}>
                                <img className='scroll-element js-scroll fade-in-bottom imagen_ch_servicios' src={img1} alt="" style={{width:"100%", maxWidth:"1485px"}}/>
                            </Efectos>
                            <p className='center cont_7' style={{color:"#707070"}}>
                                Pautar este tipo de campañas con el correcto presupuesto, 
                                segmentación geográfica y otras opciones de configuración garantizan 
                                nuevos prospectos de clientes para tu negocio.
                            </p>
                        </div>
                    )}
                </div>

                <div className='cont_2'>
                    <p className='titulo_nv_1 center' style={{color:"#BF1F60"}}>
                        ¿Qué incluye?
                    </p>
                    <div style={{display:"flex", justifyContent:"space-evenly", flexWrap:"wrap", alignItems:"stretch"}}>
                        <div className='flex_1' style={{marginTop:"0"}}>
                            <div className='box_1' style={{marginTop:"0"}}>
                                <img src={icon1} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Segmentación objetiva
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Seleccionamos el mejor público para tu campaña para aprovechar al máximo tu presupuesto.
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon3} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Atención y soporte
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Estamos para resolver cualquier duda 
                                        que presentes acerca de tu campaña.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='flex_1' style={{marginTop:"0"}}>
                            <div className='box_1' style={{marginTop:"0"}}>
                                <img src={icon2} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Reporte mensual
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Mostramos los resultados de tu campaña en reportes bien definidos para mejorar tus próximas campañas.
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon4} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Cambios de métricas
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Si es necesario, haremos constantes modificaciones 
                                        y ajustes de tu campaña para mejorarla.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{display:"flex", justifyContent:"center"}}>
                    <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                        <p class="btn_1" onClick={cambio} style={{margin:"0px", color:"#fff"}}>
                            Cotiza tu proyecto
                        </p>
                    </WavyLink>
                    {/* <div className='btn_1'>
                        <a href="/contacto" style={{color:"#fff"}}>
                            <p>
                                Cotiza tu proyecto
                            </p>
                        </a>
                    </div> */}
                </div>

                <div className='center'>
                    <p className='titulo_nv_1 padding_movil' style={{marginBottom:"0"}}>
                        ¿Cómo hacemos tu <br/>
                        <span className='titulo_nv_2 padding_movil' style={{color:"#A741AF"}}>campaña de Google ADS?</span>
                    </p>
                    <p className='cont_8' style={{color:"#707070"}}>
                        El proceso de trabajo de nuestras 
                        <b style={{color:"#BF1F60"}}> campañas de Google ADS </b> 
                        se divide en distintas etapas, 
                        cada una tan importante como la anterior.
                    </p>
                </div>

                {window.screen.width <= 992 ? (
                    <div className='cont_2' style={{display:"flex", justifyContent:"center", flexWrap:"wrap"}}>
                        <div className='box_3'>
                            <img src={img2} alt="" className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#42D4FC" , margin:"0px"}}>
                                    Definición de la campaña.
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Primero platicamos contigo para saber la meta a 
                                    alcanzar con esta campaña y todos los puntos que te gustaría destacar.                                     Te damos la <b>cotización de tu campaña.</b> 
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img3} alt="" className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#2A79B0" , margin:"0px"}}>
                                    Análisis
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Revisamos tu competencia directa y realizamos 
                                    una lista con palabras clave que garantizaran una 
                                    campaña exitosa. 
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img4} alt="" className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#134263" , margin:"0px"}}>
                                    Fijar presupuestos
                                </b >
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Definiremos un presupuesto para conseguir las 
                                    metas específicas de tu campaña y poder llegar a 
                                    más personas.
                                </p>
                            </div>
                        </div>
                        <div className='box_3'>
                            <img src={img5} alt="" className='imagen_movil_servicios_2' />
                            <div>
                                <b className='sub_titulo_nv_4' style={{color:"#BF1F60" , margin:"0px"}}>
                                    Fijar presupuestos
                                </b >
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Definiremos un presupuesto para conseguir las 
                                    metas específicas de tu campaña y poder llegar a 
                                    más personas.
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='cont_2' style={{display:"flex", justifyContent:"center", marginTop:"50px"}}>
                        <div className='flex_lateral'>
                            <div className='box_3'>
                            </div>
                            <div className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#2A79B0" , margin:"0px"}}>
                                    Análisis
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Revisamos tu competencia directa y realizamos 
                                    una lista con palabras clave que garantizaran una 
                                    campaña exitosa. 
                                </p>
                            </div>
                        </div>
                        <div className='flex_centro'>
                            <img src={imgServiciosBlanco} className="effect_fondo" alt="" style={{width:"100%"}} />
                            <div className='box_4'>
                                <div>
                                    <b className='sub_titulo_nv_4' style={{color:"#BF1F60" , margin:"0px"}}>
                                        Soporte 
                                    </b>
                                    <p style={{color:"#707070" , margin:"0px"}}> 
                                        Estamos aquí siempre que nos necesites, 
                                        ofrecemos permanente comunicación de 
                                        todo nuestro equipo para apoyarte en 
                                        cualquier situación.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='flex_lateral'>
                            <div className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#42D4FC" , margin:"0px"}}>
                                    Definición de la campaña.
                                </b>
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Primero platicamos contigo para saber la meta a 
                                    alcanzar con esta campaña y todos los puntos que te gustaría destacar. 
                                    Te damos la <b>cotización de tu campaña.</b> 
                                </p>
                            </div>
                            <div className='box_3'>
                            </div>
                            <div  className='box_3'>
                                <b className='sub_titulo_nv_4' style={{color:"#134263" , margin:"0px"}}>
                                    Fijar presupuestos
                                </b >
                                <p style={{color:"#707070" , margin:"0px"}}>
                                    Definiremos un presupuesto para conseguir las 
                                    metas específicas de tu campaña y poder llegar a 
                                    más personas.
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <Portafolio />
            <Contacto />

        </Fragment>
    )
}

export default ADS;